module.exports = __webpack_public_path__ + "static/media/yellow_circle.fd6fc247.svg";